export const updateQueryStr = (key: string, value: string | number): void => {
    const params = new URLSearchParams(window.location.search);
    params.set(key, String(value));
    window.history.replaceState({}, '', decodeURIComponent(`${window.location.pathname}?${params}`));
};

export const removeQueryStrKey = (key: string): void => {
    const params = new URLSearchParams(window.location.search);
    params.delete(key);
    window.history.replaceState({}, '', decodeURIComponent(`${window.location.pathname}?${params}`));
};

export const addUrlParam = (urlString: string, paramKey = '', paramValue = ''): string =>
    paramKey.length !== 0 ? `${urlString}${urlString.includes('?') ? '&' : '?'}${paramKey}=${paramValue}` : urlString;

export const hasParam = (key: string): boolean => {
    const params = new URLSearchParams(window.location.search);
    return params.has(key);
};
